const logoModule = require('../styles/webroot/images/zen_insure_logo.png') as string | { default: string };
const LOGO = typeof logoModule === 'string' ? logoModule : logoModule.default;

interface UnderMaintenanceProps {
    message: string;
}

export default function UnderMaintenance({ message }: UnderMaintenanceProps): ReturnType<React.FC> {
    return (
        <div className="maintenance-wrapper">
            <div className="maintenance-blob maintenance-blob--tl" />
            <div className="maintenance-blob maintenance-blob--br" />
            <div className="maintenance-blob maintenance-blob--tr" />

            <div className="maintenance-logo">
                <img src={LOGO} alt="Zen Insure" />
            </div>

            <div className="maintenance-illustration">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 280 220" fill="none">
                    <g transform="translate(60, 60)">
                        <circle cx="48" cy="48" r="28" fill="#cef7ff" stroke="#0bbddd" strokeWidth="3" />
                        <circle cx="48" cy="48" r="14" fill="#fff" stroke="#0bbddd" strokeWidth="2.5" />
                        {[0, 45, 90, 135, 180, 225, 270, 315].map((deg, i) => {
                            const rad = (deg * Math.PI) / 180;
                            const x = 48 + Math.cos(rad) * 36;
                            const y = 48 + Math.sin(rad) * 36;
                            return (
                                <rect
                                    key={i}
                                    x={x - 5}
                                    y={y - 5}
                                    width="10"
                                    height="10"
                                    rx="2"
                                    fill="#0bbddd"
                                    transform={`rotate(${deg}, ${x}, ${y})`}
                                />
                            );
                        })}
                    </g>

                    <g transform="translate(148, 38)">
                        <circle cx="32" cy="32" r="18" fill="#e8f9ff" stroke="#0bbddd" strokeWidth="2.5" />
                        <circle cx="32" cy="32" r="9" fill="#fff" stroke="#0bbddd" strokeWidth="2" />
                        {[0, 60, 120, 180, 240, 300].map((deg, i) => {
                            const rad = (deg * Math.PI) / 180;
                            const x = 32 + Math.cos(rad) * 24;
                            const y = 32 + Math.sin(rad) * 24;
                            return (
                                <rect
                                    key={i}
                                    x={x - 4}
                                    y={y - 4}
                                    width="8"
                                    height="8"
                                    rx="2"
                                    fill="#0bbddd"
                                    transform={`rotate(${deg}, ${x}, ${y})`}
                                />
                            );
                        })}
                    </g>

                    <g transform="translate(140, 100) rotate(-40, 40, 60)">
                        <rect x="34" y="30" width="12" height="60" rx="6" fill="#0bbddd" />
                        <circle cx="40" cy="26" r="14" fill="none" stroke="#0bbddd" strokeWidth="7" />
                        <rect x="33" y="12" width="14" height="14" fill="#f0fdff" />
                        <rect x="26" y="82" width="28" height="12" rx="4" fill="#0bbddd" />
                    </g>

                    <g transform="translate(80, 130) rotate(35, 20, 50)">
                        <rect x="16" y="10" width="8" height="50" rx="4" fill="#0bbddd" opacity="0.7" />
                        <rect x="14" y="60" width="12" height="30" rx="3" fill="#cef7ff" stroke="#0bbddd" strokeWidth="2" />
                        <rect x="18" y="90" width="4" height="12" rx="1" fill="#0bbddd" opacity="0.8" />
                    </g>

                    <path
                        d="M 107 88 Q 140 70 180 70"
                        stroke="#0bbddd"
                        strokeWidth="2"
                        strokeDasharray="4 4"
                        opacity="0.4"
                    />

                    <circle cx="230" cy="50" r="3" fill="#0bbddd" opacity="0.5" />
                    <circle cx="245" cy="65" r="2" fill="#0bbddd" opacity="0.3" />
                    <circle cx="220" cy="70" r="2" fill="#0bbddd" opacity="0.4" />
                    <circle cx="38" cy="150" r="3" fill="#0bbddd" opacity="0.4" />
                    <circle cx="52" cy="138" r="2" fill="#0bbddd" opacity="0.3" />
                </svg>
            </div>

            <div className="maintenance-content">
                <h1>Site Under Maintenance</h1>
                <p>{message}</p>
            </div>

            <div className="maintenance-footer">
                <div className="maintenance-footer__dots">
                    <span /><span /><span />
                </div>
                <p>Mega Box &mdash; We'll be back soon</p>
            </div>
        </div>
    );
}
